module.exports = __webpack_public_path__ + "static/media/EasyWords_web_2_preview.3a2882dc.jpg";